<template>
  <div id="quotation">
    <base-header class="bg-primary pb-6 pt-0">
      <div class="row align-items-center pb-2">
        <div class="col-lg-6 col-7">
          <breadcrumb :link="[{ name: 'Quản lý Báo giá', active: true }]"></breadcrumb>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6 bg-lighter">
      <block :nobody="true" ref="bquota" class="soft-control">
        <control-panel
          :disabled="{
            print: true
          }"
          :permission="{
            create: 'quota_create',
            delete: 'quota_delete'
          }"
          :countChecked="countChecked"
          @doAddNew="handleCreate"
          @doEdit="handleUpdate"
          @search="handleSearch"
          @copy="handleCopy"
          :help="handleHelp"
          @doDelete="handleDelete"
        ></control-panel>
        <div class="row p-1">
          <div class="col-md-12">
            <soft-table
              @rowSelected="tbSetRowSelected"
              @rowClicked="tbRowClicked"
              class="table align-items-center table-flush"
              tbody-classes="list"
              :pending="false"
              :showAll="true"
              :dataTable="tableData"
              :fields="fields"
              :minHeight="$hControl"
              :contextMenus="[
                {
                  key: 'verify',
                  icon: 'fa-users-cog',
                  label: 'Duyệt hồ sơ'
                }
              ]"
              @contextMenuItemClick="tbHandleContextMenuItemClick"
              ref="soft-table"
            >
              <template v-slot:cell(code)="row">
                <b-button @click="row.toggleDetails" variant="link">
                  {{ row.value }}
                </b-button>
              </template>
              <template v-slot:row-details="row">
                <div class="py-2" style="background:#fff">
                  <b-row align-h="center" class="mx-0">
                    <template v-if="row.item.status">
                      <b-button @click="sendQuotation(row.item)" variant="info" class="mt-2" size="lg">
                        <i class="fa fa-paper-plane" aria-hidden="true"></i>
                        Gửi báo giá
                      </b-button>
                      <b-button @click="createOrder(row.item)" variant="success" class="mt-2" size="lg">
                        <i class="fas fa-chart-line" aria-hidden="true"></i>
                        Tạo đơn hàng
                      </b-button>
                    </template>
                    <template v-else>
                      <b-button @click="verifyQuotation(row.item)" variant="success" class="mt-2" size="lg">
                        <i class="fa fa-check" aria-hidden="true"></i>
                        Duyệt báo giá
                      </b-button>
                      <b-button @click="handleUpdate(row.item)" variant="info" class="mt-2" size="lg">
                        <i class="fa fa-check" aria-hidden="true"></i>
                        Cập nhật báo giá
                      </b-button>
                    </template>

                    <b-button @click="printQuotation(row.item)" variant="primary" class="mt-2" size="lg">
                      <i class="fa fa-print" aria-hidden="true"></i>
                      In báo giá
                    </b-button>
                  </b-row>
                  <b-row class="mx-0">
                    <b-col md="4">
                      <base-input v-model="row.item.userCreate.name" readonly label="Tạo bởi"> </base-input>
                    </b-col>
                    <b-col md="4">
                      <base-input
                        :value="row.item.userVerify ? row.item.userVerify.name : 'Chưa có người duyệt'"
                        readonly
                        label="Người duyệt"
                      >
                      </base-input>
                    </b-col>
                    <b-col md="4">
                      <div class="form-group has-label">
                        <label class="form-control-label">
                          Trạng thái :
                        </label>
                        <br />
                        <h3>
                          <b-badge pill v-if="row.item.status" variant="success">
                            Đã duyệt
                          </b-badge>
                          <b-badge pill v-else variant="danger">
                            Chưa được duyệt
                          </b-badge>
                        </h3>
                      </div>
                    </b-col>
                    <b-col md="4">
                      <base-input v-model="row.item.customer.code" readonly label="Mã khách hàng"> </base-input>
                    </b-col>
                    <b-col md="4">
                      <base-input v-model="row.item.customer.name" readonly label="Tên khách hàng"> </base-input>
                    </b-col>
                    <b-col md="4">
                      <base-input v-model="row.item.customer.email" readonly label="Email khách hàng"> </base-input>
                    </b-col>
                  </b-row>
                  <hr />
                  <div class="p-2">
                    <base-table
                      v-if="row.item.orders.length > 0"
                      :data="row.item.orders"
                      style="min-height:unset; margin-bottom:15px"
                    >
                      <template slot="columns">
                        <th>STT</th>
                        <th>Mã đơn hàng</th>
                        <th>Mã PO</th>
                        <th>Ngày đặt hàng</th>
                        <th>Ngày giao hàng</th>
                        <th>Ghi chú</th>
                      </template>
                      <template slot-scope="{ row, index }">
                        <tr :key="index">
                          <td class="bg-info text-light col-fix ">
                            {{ index + 1 }}
                          </td>
                          <td class="text-center">
                            <b>{{ row.code }}</b>
                          </td>
                          <td class="text-center">
                            <b>{{ row.poCode }}</b>
                          </td>
                          <td class="text-center">
                            {{ $date(row.dateReceipt) }}
                          </td>
                          <td class="text-center">
                            {{ $date(row.dateDelivery) }}
                          </td>
                          <td v-html="row.note"></td>
                        </tr>
                      </template>
                    </base-table>
                    <base-table :data="row.item.quotaDetails">
                      <template slot="columns">
                        <th>STT</th>
                        <th>Mã sản phâm</th>
                        <th>Tên sản phẩm</th>
                        <th>Quy cách</th>
                        <th>Chiều dài</th>
                        <th>Hệ màu</th>
                        <th>Màu sắc</th>
                        <th>Mã màu</th>
                        <th class="text-right">Đơn giá</th>
                        <th class="text-right">Số lượng từ</th>
                      </template>

                      <template slot-scope="{ row, index }">
                        <tr :key="index">
                          <td class="bg-info text-light col-fix ">
                            {{ index + 1 }}
                          </td>
                          <td>{{ row.product.code }}</td>
                          <td>
                            {{ row.product.name }}
                            <!-- <span v-if="row.productCustom != ''"><br />{{ row.productCustom }}</span> -->
                            <span v-if="row.reason"><br />{{ row.reason.name }}</span>
                          </td>
                          <td class="text-center">{{ row.productSpecify.name }}mm</td>
                          <td class="text-center">{{ $formatNumber(row.length) }} cm</td>
                          <td>
                            <div
                              v-if="row.color"
                              d-block
                              :style="'background:' + row.color.color"
                              style="border:1px solid ; color: gray; padding:0px 9px;"
                            >
                              {{ row.color.label }}
                            </div>
                          </td>
                          <td>{{ row.colorText }}</td>
                          <td>{{ row.colorCode }}</td>
                          <td class="text-right">
                            {{ $formatCurrency(row.price) }} {{ row.currency }}/
                            {{ row.unit }}
                          </td>
                          <td class="text-right">{{ $formatNumber(row.quantity) }} {{ row.unit }}</td>
                        </tr>
                      </template>
                    </base-table>
                  </div>
                </div>
              </template>
              <template v-slot:cell(note)="{ value }">
                <div v-html="value"></div>
              </template>
              <template v-slot:cell(orders)="{ value }">
                <b-badge v-if="value.length > 0" variant="success">
                  Đã tạo <b>{{ value.length }}</b> đơn hàng
                </b-badge>
                <b-badge v-else>Chưa có đơn hàng</b-badge>
              </template>
              <template v-slot:cell(userCreate)="{ value }">
                <span v-if="value.id" class="badge badge-primary">{{ value.username }}</span>
              </template>
              <template v-slot:cell(userVerify)="{ value }">
                <span v-if="value.id" class="badge badge-success">{{ value.username }}</span>
                <span v-else class="badge badge-danger">
                  Chưa được duyệt
                </span>
              </template>
              <template v-slot:cell(userManage)="{ value }">
                <span v-if="value.id" class="badge badge-info">{{ value.username }}</span>
                <span v-else class="badge badge-danger">
                  Chưa có người hỗ trợ
                </span>
              </template>
              <template>
                <pagination
                  class="mr-2 my-1"
                  slot="footer"
                  :total="listQuery.total"
                  :perPage="listQuery.limit"
                  @change="pagChange"
                />
              </template>
            </soft-table>
          </div>
        </div>
      </block>
      <preview ref="preview"></preview>
    </div>
  </div>
</template>
<script>
import { quotaService } from '@/_services';
import Preview from './__Preview';
export default {
  name: 'quotation-manage',
  components: {
    Preview
  },
  data() {
    return {
      countChecked: 0,
      listQuery: {
        page: 1,
        limit: 30,
        total: 0
      },
      lastIndexSelected: 0,
      info: {},
      tableData: [],
      tableDataSelecteds: [],
      fields: [
        {
          variant: 'primary',
          key: 'id',
          class: 'col-fix checkbox'
        },
        {
          key: 'code',
          label: 'Mã báo giá',
          sortable: true,
          class: 'col-fix'
        },
        {
          key: 'customer.code',
          label: 'Mã khách hàng',
          sortable: true,
          class: 'col-fix'
        },
        {
          key: 'customer.name',
          label: 'Tên khách hàng',
          sortable: true
        },
        {
          tdClass: 'text-center',
          key: 'userCreate',
          label: 'Người tạo',
          sortable: true
        },
        {
          tdClass: 'text-center',
          key: 'userVerify',
          label: 'Người duyệt hồ sơ',
          sortable: true
        },
        {
          tdClass: 'text-center',
          key: 'orders',
          label: 'Trạng thái',
          sortable: true
        },
        {
          tdClass: 'text-center',
          key: 'dateCreated',
          sortable: true,
          label: 'Ngày tạo'
        }
      ]
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.$refs.bquota.block();
      quotaService
        .findAll(this.listQuery)
        .then(res => {
          this.tableData = res.data.data;
          this.listQuery.total = res.data.total;
          this.$refs['soft-table'].selectRow(this.lastIndexSelected);
        })
        .finally(() => {
          this.$refs.bquota.unBlock();
        });
    },
    pagChange(page) {
      this.listQuery.page = page;
      this.fetchData();
    },
    handleSearch(keyword) {
      this.listQuery.search = keyword;
      this.fetchData();
    },
    tbRowClicked(item, index) {
      this.info = item;
      this.lastIndexSelected = index;
    },
    tbHandleContextMenuItemClick(a) {
      if (a.menu.key == 'verify') {
        this.verifyQuotation(a.data);
      }
    },
    handleUpdate(item) {
      if (item) {
        this.info = item;
      }
      if (this.info.status) {
        this.$swal({
          title: 'Chỉ có thể sửa báo giá chưa duyệt?',
          text: 'Báo giá này đã duyệt rồi không thể sửa',
          type: 'warning',
          showCancelButton: false,
          confirmButtonText: 'OK',
          cancelButtonText: 'Không',
          reverseButtons: true
        }).then(function() {});
      } else {
        this.$router.push({
          name: 'add-quotation',
          query: {
            edit_id: this.info.id
          }
        });
      }
    },
    handleCreate() {
      this.$router.push({
        name: 'add-quotation'
      });
    },
    handleCopy() {
      this.$router.push({
        name: 'add-quotation',
        query: {
          copy_id: this.info.id
        }
      });
    },
    handleHelp() {
      alert('help');
    },
    handleDelete() {
      if (this.countChecked == 0) return;
      let listRemove = [];
      for (let i = 0; i < this.tableDataSelecteds.length; i++) {
        const element = this.tableDataSelecteds[i];
        if (element.userVerify && element.userVerify.id) {
          this.$alertify.success('Không thể xóa báo giá đã duyệt', {
            duration: 4000
          });
          return;
        }
        listRemove.push(element.id);
      }
      this.$refs.bquota.block();
      quotaService
        .removeList(listRemove)
        .then(res => {
          this.lastIndexSelected = 0;
          this.$alertify.success(res.message, {
            duration: 4000
          });
        })
        .finally(() => {
          this.fetchData();
          this.$refs.bquota.unBlock();
        });
    },
    tbSetRowSelected(items) {
      this.tableDataSelecteds = items;
      this.countChecked = items.length;
      if (items.length == 1) {
        this.info = items[0];
      }
    },
    verifyQuotation(item) {
      this.$refs.bquota.block();
      quotaService
        .verify(item.id)
        .then(res => {
          item.status = true;
          item.userVerify = res.data.userVerify;
          this.$alertify.success(res.message, {
            duration: 4000
          });
        })
        .finally(() => {
          this.$refs.bquota.unBlock();
        });
    },
    createOrder(item) {
      this.$router.push({
        name: 'add-order',
        query: {
          id_quotation: item.id
        }
      });
    },
    sendQuotation(item) {
      this.$refs.bquota.block();
      quotaService
        .sendEmail(item.id)
        .then(res => {
          this.$alertify.success(res.message, {
            duration: 4000
          });
        })
        .finally(() => {
          this.$refs.bquota.unBlock();
        });
    },
    printQuotation(item) {
      this.$refs.preview.visible = true;
      this.$refs.preview.setData(item, item.quotaDetails);
    }
  }
};
</script>
<style lang="scss">
.soft-table {
  .b-table-sticky-header {
    max-height: 400px;
  }
}
</style>
